import React, { useContext, useEffect, useState } from "react";
import {
  FaPaperPlane,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";

import { GlobalContext } from "../Context/GlobalState";
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const { userdetail, setTransactionLoaderState } = useContext(GlobalContext);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
    <div>
      <Row>
        <Col md={7} className="p-3 bg-white">
          <h4 className="mb-2">Send us a Query</h4>
          <Form onSubmit={handleSubmit}>
            <Row className="p-0 m-0">
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your e-mail"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="p-0 m-0">
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    placeholder="Enter mobile number"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="p-0 m-0">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                placeholder="Enter your query"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="d-flex align-items-center mt-2"
            >
              <FaPaperPlane className="me-2" /> Send Message
            </Button>
          </Form>
        </Col>

        <Col md={5} className="p-0 m-0 ">
          <Card className="p-0 m-0" style={{ background: "#27548a" }}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7001.0000000000005!2d77.3705!3d28.6056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce54d43b8b9e9%3A0x3e3f9f1b2f1c6c3a!2sIthum%20Tower%2C%20Sector%2062%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1633500000000!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
            <div className="p-3">
              <div className="mt-3 d-flex align-items-center">
                <FaMapMarkerAlt className="text-white" /> &nbsp;&nbsp;
                <p className="mb-0 text-white">
                  B 212 Ithum Tower, Sector 62, Noida, Uttar Pradesh, 201301
                </p>
              </div>
              <div className="mt-3 d-flex align-items-center">
                <FaPhone className="text-white" /> &nbsp;&nbsp;
                <p className="mb-0 text-white">(800) 900-200-300</p>
              </div>
              <div className="mt-3 d-flex align-items-center">
                <FaEnvelope className="text-white" /> &nbsp;&nbsp;
                <p className="mb-0 text-white">support@seobix.com</p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactForm;
